// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:640px){table[data-v-4188aa96]{display:inline-table!important}thead tr[data-v-4188aa96]:not(:first-child){display:none}}th[data-v-4188aa96]:not(:last-child){border-bottom:1px solid rgba(0,0,0,.1)}table[data-v-4188aa96]{table-layout:fixed;width:100%}table td[data-v-4188aa96]{word-wrap:break-word;overflow-wrap:break-word}", ""]);
// Exports
module.exports = exports;
